import { gql } from 'graphql-request'

export const CREATE_MAIN_BANNER = gql`
  mutation CreateMainBanner($createMainBannerInput: CreateMainBannerInput!) {
    createMainBanner(createMainBannerInput: $createMainBannerInput) {
      id
    }
  }
`
